import Axios from '../lib/axios'
import store from '@/store'

class MedicalExamsService {
  async all (patientId, typeId = null) {
    let params = {}
    if (typeId != null) {
      params.typeId = typeId
    }
    const result = await Axios.authenticated().get(`/medical-exams/${patientId}`, {params: params})
    return result
  }

  async allWithPatient () {
    const result = await Axios.authenticated().get(`/medical-exams`, {})
    return result
  }

  async create (exam) {
    let newExam = JSON.parse(exam.get('exam'))
    let config = {
      onUploadProgress: e => store.state.currentProgress = Math.round(e.loaded * 100 / e.total),
      headers: {
        path: newExam.patientId
      }
    }
    const result = await Axios.authenticated().post(
      `/medical-exams/${newExam.patientId}`,
      exam,
      config
    )
    return result
  }

  async update (exam) {
    let newExam = JSON.parse(exam.get('exam'))
    let config = {
      onUploadProgress: e => store.state.currentProgress = Math.round(e.loaded * 100 / e.total),
      headers: {
        path: newExam.patientId
      }
    }
    const result = await Axios.authenticated().put(
      `/medical-exams/${newExam.patientId}`,
      exam,
      config
    )
    return result
  }

  async delete (exam) {
    const result = await Axios.authenticated().delete(`/medical-exams/${exam.patientId}`, { data: { id: exam._id } })
    return result
  }
}

export default new MedicalExamsService()
